import Vue from 'vue';
import { ActionTree, MutationTree, GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { ServerResult } from '@/core/http/server_result';
import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment';
import numeral from 'numeral'

interface ShiftVDPSoufflingState {
    loaded: boolean;
    loading: boolean;
    fatalError: boolean;

    documentId: any;
    clientId: any;

    // productList: any[];
    // productVariantList: any[];
    prefereds: any;
    souffling_list: any[];
    shift_souffling_list: any[];
    plan_list: any[];
    schemas: any;
}

const state: ShiftVDPSoufflingState = {
    loading: false,
    loaded: false,
    fatalError: false,

    documentId: null,
    clientId: null,

    // productList: [],
    // productVariantList: [],
    prefereds: [],
    souffling_list: [],
    shift_souffling_list: [],
    plan_list: [],
    schemas: {}
};

const initState: any = cloneDeep(state);

const GET_PLAN_LINES_LIST = 'GET_PLAN_LINES_LIST';
const GET_LINES_SOUFFLING_LIST = 'GET_LINES_SOUFFLING_LIST';
const GET_SHIFT_SOUFFLING_LIST = 'GET_SHIFT_SOUFFLING_LIST';

const mapper: any = {
  '[[рецепт.кол-воды]]': (data: any) => {
    const _temp = parseFloat(data.temp)
    const borders = (data.water_borders && data.water_borders.borders ? data.water_borders.borders : []).filter((item: any, idx: number) => {
      return item.temp < _temp;
    });
    const coef = borders.length ? borders[borders.length - 1].coef : 0

    return numeral((parseFloat(data.water) / coef + data.plus_water) / 1000).format('0.00')
  }
}
const format_text = (text: any, data: any) => {
  const _t = {text: text}
  Object.keys(mapper).map((key: any) => {
    if (_t.text.indexOf(key) > -1) {
      _t.text = _t.text.replace(key, mapper[key](data))
    }
  }) 
  return _t.text
}

export const actions: ActionTree<ShiftVDPSoufflingState, RootState> = {
    reset({ commit }) {
        commit('RESET_STATE')
    },
    loadPlans({ commit }, { documentId }) {
      const vm = (this as any)._vm;
      
      commit('START_LOADING');
      
      state.documentId = documentId;

      return new Promise((resolve, reject) => {
        vm.$db([
          vm.$q(GET_PLAN_LINES_LIST)
              .raw('documents.list')
              .action({
                columns: {
                  id: 'sfpv.id',
                  plan_id: 'spv.id',
                  shift_id: 'sfpv.shift_id',
                  line_id:  {$case: [
                    [
                      {$null: ['spv.line_id']},
                      'wash_line.id'
                    ],
                    [
                      {$: true},
                      'spv.line_id'
                    ]
                  ]},
                  number: 'sfpv.number',
                  base_name: {
                    $case: [
                      [
                        {$null: ['base.name']},
                        {$concat: [{$: 'Мойка'}, {$: ' '}]}
                      ],
                      [
                        {
                          "$": true
                        },
                        {$concat: ['base.name', {$: ' '}, 'vst.name']}
                      ]
                    ]
                  },
                  done_delay: 'base.done_delay',
                  fact_id: 'sfv.id',
                  wash_id: 'spw.id',
                  is_done: {$case: [
                    [
                      {$null: ['sfv.id']},
                      'spw.is_done'
                    ],
                    [
                      {$: true},
                      'sfv.is_done'
                    ]
                  ]},
                  done_time: {$case: [
                    [
                      {$null: ['sfv.id']},
                      'spw.done_time'
                    ],
                    [
                      {$: true},
                      'sfv.done_time'
                    ]
                  ]},
                  frozen_time: 'sjv.frozen_time',
                  is_prev: {$not: [{$eq: [`spv.shift_id`, {$: documentId}]}]},
                  ignore_done_delay: 'spv.ignore_done_delay',
                  equipment_id: 'spw.equipment_id',
                  volume_name: 'vv.name',
                  fields: {$obj: {
                    water: 'p.water',
                    plus_water: 'p.plus_water',
                    water_borders: 'p.water_borders',
                    temp: 'sjv.water_temp'
                  }}
                },
                from: 's:shift_full_plan_vdp',
                from_as: 'sfpv',
                joins: [
                  {
                    join: 's:shift_plan_vdp',
                    type: 'left',
                    as:   'spv',
                    on: {
                      $and: [
                        {$eq: ['sfpv.plan_id', 'spv.id']}
                      ]
                    }
                  },
                  {
                    join: 's:voc_bases',
                    type: 'left',
                    as:   'base',
                    on: {
                      $eq: ['spv.base_id', 'base.id']
                    }
                  },
                  {
                    join: 's:prescripts',
                    type: 'left',
                    as:   'p',
                    on: {
                      $and: [
                        {$eq: ['base.id', 'p.base_id']},
                        {$null: ['p.archived_at']}
                      ]
                    }
                  },
                  {
                    join: 's:voc_starter_types',
                    type: 'left',
                    as:   'vst',
                    on: {
                      $eq: ['vst.id', 'spv.starter_type_id']
                    }
                  },
                  {
                    join: 's:shift_fact_vdp',
                    type: 'left',
                    as:   'sfv',
                    on: {
                      $eq: ['sfv.shift_plan_id', 'spv.id']
                    }
                  },
                  {
                    join: 's:shift_journal_vdp',
                    type: 'left',
                    as:   'sjv',
                    on: {
                      $eq: ['sjv.fact_id', 'sfv.id']
                    }
                  },
                  {
                    join: {
                      columns: {
                        id: 'base.id',
                      },
                      from: 's:shifts',
                      from_as: 's',
                      joins: [
                        {
                          join: 's:shifts',
                          type: 'left',
                          as:   'base',
                          on: {
                            $and: [
                              { $lt: ['base.real_end_time', 's.real_begin_time']},
                              { $eq: ['base.line_id', 's.line_id']},
                              { $not: [ { $null: [`base.real_end_time`] } ] }
                            ]
                          }
                        },
                      ],
                      where: {
                        $eq: [`s.id`, {$: documentId}]
                      },
                      order: [
                        {$desc: ['base.real_end_time']}
                      ],
                      page: 0,
                      page_size: 1
                    },
                    type: 'left',
                    as: 'prev_spv',
                    on: { $eq: ['spv.shift_id', 'prev_spv.id'] }
                  },
                  {
                    join: 's:shift_plan_washing',
                    type: 'left',
                    as:   'spw',
                    on: {
                      $eq: ['sfpv.wash_id', 'spw.id']
                    }
                  },
                  {
                    join: 's:voc_volumes_washings',
                    type: 'left',
                    as:   'vvw',
                    on: {
                      $and: [
                        {$eq: ['vvw.id', 'spw.washing_id']},
                      ]
                    }
                  },
                  {
                    join: {
                      columns: {
                        id: 'vl.id',
                      },
                      from: 's:voc_lines',
                      from_as: 'vl',
                      where: {
                        $eq: [`vl.templates`, {$: 'wash'}]
                      },
                      page: 0,
                      page_size: 1
                    },
                    type: 'left',
                    as: 'wash_line',
                    on: { $eq: ['sfpv.wash_id', 'spw.id'] }
                  },
                  {
                    join: 's:voc_volumes',
                    type: 'left',
                    as:   'vv',
                    on: {
                      $and: [
                        {$eq: ['vv.id', 'vvw.volume_id']},
                      ]
                    }
                  },
                ],
                page_size: 10000,
                page: 1,
                order: [
                  {$asc: ['sfpv.id']}
                ],
                where:
                  {$and: [
                    {$or: [
                      {$eq: [`sfpv.shift_id`, {$: documentId}]},
                      {$not: [ { $null: [`prev_spv.id`] } ]},
                    ]},
                    {$null: ['spv.deleted_at']}
                  ]}
              }),
        ]).then((result: ServerResult) => {
          const opPlanListResult = result.getOperation(GET_PLAN_LINES_LIST);

          const groupsByNumber = opPlanListResult.getContent().documents.reduce((prev: any, item: any) => {
            if (item.number) {
              const _key = item.number.split('.')[0] + '-' + item.shift_id;
              if (!prev[_key]) {
                prev[_key] = []
              }
              prev[_key].push(item.plan_id ? item.plan_id : item.wash_id);
            }
            return prev
          }, {})

          const planList = opPlanListResult.getContent().documents.map((item: any) => {
            const _key = item.number.split('.')[0] + '-' + item.shift_id;
            item.plans = groupsByNumber[_key];
            return item;
          }).filter((item: any) => {
            return item.number.split('.').length == 1
          })
          state.plan_list = planList;
          resolve(null);
        })
      })
    },

    loadData({ commit, getters, dispatch, state }, { documentId, lineId, equipmentId, types }) {
        const vm = (this as any)._vm;

        state.documentId = documentId;
      commit('START_LOADING');

        return new Promise((resolve, reject) => {
          vm.$db([
            vm.$q('SCHEMA_SFV')
                .raw('schemas.get')
                .action({
                    id: `s:shift_fact_vdp`
                }),
            vm.$q('SCHEMA_SJV')
                .raw('schemas.get')
                .action({
                    id: `s:shift_journal_vdp`
                }),
            vm.$q(GET_LINES_SOUFFLING_LIST)
              .raw('documents.list')
              .action({
                columns: {
                  id: 'vls.id',
                  text: 'vls.text',
                  equipment_id: 'vls.equipment_id',
                  with_button: 'vls.with_button',
                  button_label: 'vls.button_label',
                  field_taget: 'vlsf.target',
                  field_type: 'vlsf.type',
                  field_label: 'vlsf.label',
                  field_id: 'vlsf.id',
                },
                from: 's:voc_lines_souffling',
                from_as: 'vls',
                joins: [
                  {
                    join: 's:voc_lines_souffling_fields',
                    type: 'left',
                    as:   'vlsf',
                    on: {
                      $eq: ['vls.field_id', 'vlsf.id']
                    }
                  },
                ],
                page_size: 10000,
                page: 1,
                order: [
                  {$asc: ['vls.position']},
                  {$asc: ['vls.id']}
                ],
                where: {
                  $and: [
                    {$eq: [`vls.line_id`, {$: lineId}]},
                    ...(equipmentId ? [{$eq: [`vls.equipment_id`, {$: equipmentId}]}] : []),
                    {$in: [`vls.type`, {$: types}]},
                  ]
                }
              }),
            
            vm.$q(GET_SHIFT_SOUFFLING_LIST)
              .raw('documents.list')
              .action({
                columns: {
                  id: 'ss.id',
                  souffling_id: 'ss.souffling_id',
                  shift_plan_id: 'ss.shift_plan_id',
                  shift_plan_washing_id: 'ss.shift_plan_washing_id',
                  is_accepted: 'ss.is_accepted',
                  manager_name: 'employee.name',
                  updated_at: 'ss.updated_at',
                },
                from: 's:shift_souffling',
                from_as: 'ss',
                joins: [
                  {
                    join: 's:employees',
                    type: 'left',
                    as:   'employee',
                    on: {
                      $eq: ['employee.id', 'ss.manager_id']
                    }
                  },
                  {
                    join: {
                      columns: {
                        id: 'base.id',
                      },
                      from: 's:shifts',
                      from_as: 's',
                      joins: [
                        {
                          join: 's:shifts',
                          type: 'left',
                          as:   'base',
                          on: {
                            $and: [
                              { $lt: ['base.real_end_time', 's.real_begin_time']},
                              { $eq: ['base.line_id', 's.line_id']},
                              { $not: [ { $null: [`base.real_end_time`] } ] }
                            ]
                          }
                        },
                      ],
                      where: {
                        $eq: [`s.id`, {$: documentId}]
                      },
                      order: [
                        {$desc: ['base.real_end_time']}
                      ],
                      page: 0,
                      page_size: 1
                    },
                    type: 'left',
                    as: 'prev_spv',
                    on: { $eq: ['ss.shift_id', 'prev_spv.id'] }
                  },
                ],
                page_size: 10000,
                page: 1,
                order: [
                  {$asc: ['ss.id']}
                ],
                where: {
                  $or: [
                    {$eq: [`ss.shift_id`, {$: documentId}]},
                    {$not: [ { $null: [`prev_spv.id`] } ]},
                  ],
                }
              }),
          ]).then((result: ServerResult) => {
            const opRelResult = result.getOperation(GET_LINES_SOUFFLING_LIST);
            const opListResult = result.getOperation(GET_SHIFT_SOUFFLING_LIST);

            if (!opRelResult.hasError() && !opRelResult.hasError()) {
              state.shift_souffling_list = opListResult.getContent().documents
              state.schemas.shift_fact_vdp = result.getOperation('SCHEMA_SFV').getContent().schema
              state.schemas.shift_journal_vdp = result.getOperation('SCHEMA_SJV').getContent().schema

              const shift_souffling: any = {}
              state.shift_souffling_list.map((item: any) => {
                const _key = item.shift_plan_id ? item.shift_plan_id : item.shift_plan_washing_id;
                if (!shift_souffling[_key]) {
                  shift_souffling[_key] = {}
                }
                shift_souffling[_key][item.souffling_id] = item
              })
              state.souffling_list = state.plan_list.reduce((prev: any, plan: any) => {
                prev[plan.id] = opRelResult.getContent().documents.map((item: any) => {
                  const _key = plan.plan_id ? plan.plan_id : plan.wash_id;
                  const _new_item = cloneDeep(item)
                  _new_item.text = format_text(_new_item.text, plan.fields)
                  if (shift_souffling[_key] && shift_souffling[_key][_new_item.id]) {
                    _new_item.shift_souffling = shift_souffling[_key][_new_item.id]
                  }
                  _new_item.shift_plan_id = plan.plan_id
                  _new_item.wash_id = plan.wash_id
                  _new_item.plans = plan.plans
                  _new_item.value = null
                  return cloneDeep(_new_item)
                })
                return prev
              }, {})
            }
            resolve(null);
            commit('LOADED_SUCCESS');
          });
        })
    },

    setAccepted({state, dispatch, commit, rootState}, {documentId, item}) {
      const vm = (this as any)._vm;
      return new Promise((resolve, reject) => {
        commit('START_LOADING');
        let saveQuery = null;
        if (item.shift_souffling) {
            saveQuery = vm.$q('SHIFT_DATA_SAVE')
                .update(item.shift_souffling.id, {
                  is_accepted: true,
                  manager_id: (rootState as any).ubic.actor.document.id
                })
        } else {
            saveQuery = vm.$q('SHIFT_DATA_SAVE')
                .create('s:shift_souffling', {
                  shift_id: documentId,
                  souffling_id: item.id,
                  shift_plan_id: item.shift_plan_id,
                  shift_plan_washing_id: item.wash_id,
                  is_accepted: true,
                  manager_id: (rootState as any).ubic.actor.document.id
                })
        }
        const queries = [
          saveQuery
        ]
        let field_name: any = null;
        if (item.field_taget) {
          field_name = item.field_taget.field_name;
        }

        if (item.field_id) {
          item.plans.map((plan_id: any) => {
            queries.push(
              plan_id.startsWith('d:shift_plan_washing') ?
              vm.$q("SET_SOUFFLINGVALUE-" + plan_id)
              .raw('set_wash_soufling_value')
              .action({
                field_id: item.field_id,
                plan_washing_id: plan_id,
                shift_id: documentId,
                value: item.value,
                field_name: field_name
              }) :
              vm.$q("SET_SOUFFLINGVALUE-"+plan_id)
                .raw('set_soufling_value')
                .action({
                  field_id: item.field_id,
                  shift_plan_id: plan_id,
                  shift_id: documentId,
                  value: item.value
                })
            )
          })
        }

        vm.$db(queries).then((result: ServerResult) => {
          resolve(null)
          commit('LOADED_SUCCESS');
        });
      })
    },

    setDone({state, commit}, {plan}) {
      console.log(plan)
      const vm = (this as any)._vm;
      return new Promise((resolve, reject) => {
        let done_time = plan.frozen_time ? moment(plan.frozen_time) : moment();

        if (plan.ignore_done_delay) {
          done_time = done_time.add(plan.done_delay.secs, 'seconds');
        }

        const queries: any[] = [
          vm.$q('SHIFT_DATA_SAVE')
                .update(plan.fact_id ? plan.fact_id : plan.wash_id, {
                  is_done: true,
                  done_time: done_time.utc().local().format('YYYY-MM-DD HH:mm:ss')
                })
        ];
        commit('START_LOADING');
        vm.$db(queries).then((result: ServerResult) => {
          resolve(null)
          commit('LOADED_SUCCESS');
        });
      })

    },

    setItemValue({state, commit}, {plan_id, index, newValue}) {
      commit('SET_ITEM_VALUE', {plan_id, index, newValue})
    }
};

export const mutations: MutationTree<ShiftVDPSoufflingState> = {
  RESET_STATE: (state) => {
      for(const key in initState) {
          (state as any)[key] = initState[key]
      }
  },
  START_LOADING: (state) => {
      state.loaded = false;
      state.loading = true;
      state.fatalError = false;
  },
  LOADED_SUCCESS: (state) => {
      state.loaded = true;
      state.loading = false;
      state.fatalError = false;
  },
  LOADED_ERROR: (state) => {
      state.loaded = true;
      state.loading = false;
      state.fatalError = true;
  },

  SET_ITEM_VALUE: (state, {plan_id, index, newValue}) => {
    console.log('SET_ITEM_VALUE', state.souffling_list[plan_id], plan_id, index, newValue)
    state.souffling_list[plan_id][index].value = newValue
  }
};

export const getters: GetterTree<ShiftVDPSoufflingState, RootState> = {
  shift_souffling_list: (state: ShiftVDPSoufflingState) => {
    const shift_souffling: any = {}
    state.shift_souffling_list.map((item: any) => {
      shift_souffling[item.souffling_id] = item
    })

    return state.souffling_list.map((item: any) => {
      if (shift_souffling[item.id]) {
        item.shift_souffling = shift_souffling[item.id]
      }
      return item
    })
  }
};

export const STORE_KEY = '$_shift_vdp_souffling_list';

export const store = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
